<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: MessageBar                                            |
| Section: components                                              |
| Purpose: Inline message bar for status, warning, and info text. |
+------------------------------------------------------------------+
-->
<template>
    <div class="message-bar" data-nosnippet>
        <span>{{ message }}:&nbsp;
            <a href="https://whydonate.com/fundraising/sejarah-thumann" target="_blank">{{ $t('messageBar.donateCta') }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                    <path fill="#ffffff"
                        d="M384 64C366.3 64 352 78.3 352 96C352 113.7 366.3 128 384 128L466.7 128L265.3 329.4C252.8 341.9 252.8 362.2 265.3 374.7C277.8 387.2 298.1 387.2 310.6 374.7L512 173.3L512 256C512 273.7 526.3 288 544 288C561.7 288 576 273.7 576 256L576 96C576 78.3 561.7 64 544 64L384 64zM144 160C99.8 160 64 195.8 64 240L64 496C64 540.2 99.8 576 144 576L400 576C444.2 576 480 540.2 480 496L480 416C480 398.3 465.7 384 448 384C430.3 384 416 398.3 416 416L416 496C416 504.8 408.8 512 400 512L144 512C135.2 512 128 504.8 128 496L128 240C128 231.2 135.2 224 144 224L224 224C241.7 224 256 209.7 256 192C256 174.3 241.7 160 224 160L144 160z" />
                </svg></a></span>
    </div>
</template>

<script>
export default {
    name: 'MessageBar',
    props: {
        message: {
            type: String,
            required: true
        }
    }
};
</script>

<style>
.message-bar {
    /* background-color: var(--brand-color-3); */
    /* background-color: #47A025; */
    background-color: #1d1d1d;
    /* color: var(--brand-text-dark); */
    color: var(--brand-text-light);
    padding: 12px 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    /* position: fixed; */
    /* top: 0; */
    width: 100%;
    z-index: 1000;
    position: relative;
}

.message-bar span {
    display: flex;
    flex-direction: row;
    gap: 0;
    width: 100%;
}

.message-bar a {
    color: #FFF;
    text-decoration: underline;
    font-weight: 600;
}

.message-bar a:hover {
    color: #FFF;
    text-decoration: none;
}

.message-bar a svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    fill: #FFF;
}

@media (max-width: 1320px) {
    .message-bar {
        padding: 12px 24px;
        justify-content: flex-start;
    }

    .message-bar span {
        flex-direction: column;
        gap: 4px;
    }
}
</style>
